<template>
  <div class="dropdown-wrapper">
    <b-form-select
      class="dropdown-control"
      v-bind="$attrs"
      :value="value"
      :options="options"
      :multiple="multiple"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
    <svg
      v-if="!multiple"
      class="dropdown-chevron"
      viewBox="0 0 16 16"
      aria-hidden="true"
    >
      <path d="m3 6 5 5 5-5" />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Dropdown",
  inheritAttrs: false,
  props: {
    value: {
      type: [Array, Boolean, Number, Object, String],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.dropdown-wrapper {
  position: relative;
  height: 42px;
  margin-bottom: 10px;
  width: 100%;
}

#app .dropdown-wrapper .dropdown-control.custom-select {
  height: 42px !important;
  margin-bottom: 0 !important;
  padding: 0 42px 0 20px !important;
  background: #ffffff !important;
  background-image: none !important;
  border: 1px solid #aebfc7 !important;
  border-radius: 32px !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: normal !important;
}

.dropdown-chevron {
  position: absolute;
  top: 13px;
  right: 18px;
  z-index: 1;
  width: 16px;
  height: 16px;
  color: #252734;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
  pointer-events: none;
}
</style>
